import { render, staticRenderFns } from "./SuperadminVersions.vue?vue&type=template&id=0bbd4d16&scoped=true&"
import script from "./SuperadminVersions.vue?vue&type=script&lang=js&"
export * from "./SuperadminVersions.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminVersions.vue?vue&type=style&index=0&id=0bbd4d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd4d16",
  null
  
)

export default component.exports